<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="fetch">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          @click="handleCreate"
        >
          创建
        </el-button>
        <el-button
          style="margin-right: 10px"
          type="danger"
          @click="batchDelete"
        >
          删除
        </el-button>
      </div>
    </customize-page>

    <el-dialog title="创建" width="400px" :visible.sync="showDialog">
      <el-form ref="form" :rules="rules" :model="form" label-width="120px">
        <el-form-item label="订单号" prop="merchantOrderNoList">
          <el-input
            type="textarea"
            autosize
            v-model="form.merchantOrderNoList"
            placeholder="请输入订单号,多个单号以回车换行"
          />
        </el-form-item>
        <el-form-item label="原商品料号">
          <el-input v-model="form.originItemNo"></el-input>
        </el-form-item>
        <el-form-item label="替换商品料号" prop="itemNo">
          <el-input v-model="form.itemNo"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="close">取消 </el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Page from "@/mixin/Page";
import CustomizePage from "@/components/customize-page";
import itemNoMappingApi from "@/api/itemNoMappingApi";
import _ from "lodash";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      dataList: [],
      form: {
        merchantOrderNoList: "",
        originItemNo: "",
        itemNo: "",
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        { title: "订单号", key: "merchantOrderNo", align: "center" },
        {
          title: "原商家配置商品料号",
          key: "originItemNo",
          align: "center",
        },
        {
          title: "替换商品料号",
          key: "itemNo",
          align: "center",
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          align: "center",
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          render: (h, param) => {
            let data = param.row;
            return (
              <div>
                <a style="color:blue" onClick={this.delete.bind(this, data)}>
                  删除
                </a>
              </div>
            );
          },
        },
      ],
      rules: {
        merchantOrderNoList: [
          { required: true, message: "请输入订单号", trigger: "change" },
        ],
        itemNo: [
          { required: true, message: "请输入替换料号", trigger: "change" },
        ],
      },
      filterObj: {
        merchantOrderNo: "",
        originItemNo: "",
        itemNo: "",
      },
      currentShowData: {},
      currentRow: [],
      sortObj: {},
    };
  },
  methods: {
    handleCreate() {
      this.showDialog = true;
    },
    close() {
      this.form = {};
      this.showDialog = false;
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const merchantOrderNoList = this.form.merchantOrderNoList;
          const list = merchantOrderNoList.split("\n");
          itemNoMappingApi
            .create({
              request: {
                merchantOrderNoList: list,
                originItemNo: this.form.originItemNo || null,
                itemNo: this.form.itemNo || null,
              },
            })
            .then((res) => {
              if (res.value) {
                this.$message.success("创建成功");
                this.close();
                this.form = {};
              }
              this.loading = false;
              this.fetch();
            })
            .catch((err) => {
              this.fetch();
              this.loading = false;
            });
        }
      });
    },
    show(row) {
      this.showDialog = true;
      this.currentShowData = row;
    },
    delete(row) {
      this.$confirm("确认删除该条数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemNoMappingApi.delete({ itemNoMappingId: row.id }).then((res) => {
          this.$message.success("删除成功");
          this.fetch();
        });
      });
    },
    hide() {
      this.showDialog = false;
    },
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();

      itemNoMappingApi
        .pageQuery({
          request: {
            merchantOrderNo: filterParams.merchantOrderNo,
            originItemNo: filterParams.originItemNo,
            itemNo: filterParams.itemNo,
            pageInfo: {
              currentPage: this.pagination.currentPage,
              pageSize: this.pagination.pageSize,
            },
          },
        })
        .then((res) => {
          this.dataList = res.items;
          this.pagination.currentPage = res.page.pageIndex;
          this.pagination.pageSize = res.page.pageSize;
          this.pagination.totalCount = res.page.totalCount;
          this.loading = false;
        });
    },
    batchDelete() {
      if (this.currentRow.length <= 0) {
        this.$message.warning("请勾选需要删除的数据");
        return;
      }
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const promiseArr = [];
        for (let index in this.currentRow) {
          promiseArr.push(
            itemNoMappingApi.delete({
              itemNoMappingId: this.currentRow[index].id,
            })
          );
        }
        Promise.all(promiseArr).then(() => {
          this.$message.success("删除成功");
          this.fetch();
        });
      });
    },

    selectionChange(row) {
      this.currentRow = row;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "商户订单号",
              model: "merchantOrderNo",
              type: type.INPUT,
            },
            {
              label: "原商家配置商品料号",
              model: "originItemNo",
              type: type.INPUT,
            },
            {
              label: "替换商品料号",
              model: "itemNo",
              type: type.INPUT,
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scope>
.inline-p {
  display: inline-block;
  span {
    color: red;
  }
}
</style>
